import React, { FC } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './noMoreChance.module.scss';
const cx = classnames.bind(styles);

interface INoMoreChanceModalProps {
  visible: boolean;
  onClose: () => void;
}

const NoMoreChanceModal: FC<INoMoreChanceModalProps> = ({ visible, onClose }) => {
  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>응시 기회를 모두 소진하셨어요.</strong>
        <p className={cx('desc')}>응시 기회는 매월 1일에 갱신됩니다.</p>
        <a className={cx('btnClose')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close</span>
          확인
        </a>
      </div>
    </Modal>
  );
};

export default NoMoreChanceModal;
